<template>
  <footer class="app-footer">
    <UiContainer>
      <div class="app-footer__grid">
        <div class="app-footer__col">
          <div class="app-footer__logo">
            <img src="/logo.svg" alt="ЛабАктив" width="32" height="32" />
            <div>
              <span class="app-footer__logo-title">ЛабАктив</span>
              <span class="app-footer__logo-sub">Снабжение и закупки</span>
            </div>
          </div>
          <p class="app-footer__text">
            B2B-платформа для поиска и закупки оборудования, материалов и расходников у поставщиков.
          </p>
        </div>
        <div class="app-footer__col">
          <h4 class="app-footer__heading">Компания</h4>
          <router-link to="/about" class="app-footer__link">О нас</router-link>
          <router-link v-if="isSupplierShowcaseEnabled" to="/suppliers" class="app-footer__link">
            Поставщики
          </router-link>
          <router-link to="/contacts" class="app-footer__link">Контакты</router-link>
          <router-link to="/delivery" class="app-footer__link">Доставка</router-link>
        </div>
        <div class="app-footer__col">
          <h4 class="app-footer__heading">Услуги</h4>
          <router-link to="/catalog" class="app-footer__link">Каталог</router-link>
          <router-link
            v-if="((isBuyer || isSupplier) && isProcurementEnabled) || isAdmin"
            :to="isProcurementEnabled ? '/procurements' : '#'"
            class="app-footer__link"
          >
            Закупки
          </router-link>
          <router-link to="/help" class="app-footer__link">Помощь</router-link>
        </div>
        <div class="app-footer__col">
          <h4 class="app-footer__heading">Контакты</h4>
          <p class="app-footer__text">+7 (951) 852-06-24</p>
          <p class="app-footer__text">info@labactive.ru</p>
          <p class="app-footer__text">Москва</p>
        </div>
<!--        <div class="app-footer__col">-->
<!--          <h4 class="app-footer__heading">Социальные сети</h4>-->
<!--          <a href="#" class="app-footer__link">Telegram</a>-->
<!--          <a href="#" class="app-footer__link">WhatsApp</a>-->
<!--          <a href="#" class="app-footer__link">Email</a>-->
<!--        </div>-->
      </div>
      <div class="app-footer__divider" />
      <div class="app-footer__bottom">
        <span class="app-footer__copy">© 2026 ЛабАктив. Все права защищены.</span>
        <div class="app-footer__legal">
          <router-link to="/privacy" class="app-footer__link">Политика конфиденциальности</router-link>
          <router-link to="/terms" class="app-footer__link">Условия использования</router-link>
        </div>
      </div>
    </UiContainer>
  </footer>
</template>

<script setup lang="ts">
import UiContainer from '@/shared/ui/UiContainer.vue'

defineProps<{
  isSupplierShowcaseEnabled: boolean
  isProcurementEnabled: boolean
  isBuyer: boolean
  isSupplier: boolean
  isAdmin: boolean
}>()
</script>

<style scoped>
.app-footer {
  margin-top: 48px;
  padding: 32px 0 24px;
  background: #f1f5f9;
  border-top: 1px solid #e2e8f0;
}

.app-footer__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
}

.app-footer__col {
  min-width: 0;
}

.app-footer__logo {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 28px;
  margin-bottom: 16px;
}

.app-footer__logo-title {
  font-size: 16px;
  font-weight: 600;
  display: block;
}

.app-footer__logo-sub {
  font-size: 12px;
  color: #586578;
}

.app-footer__heading {
  margin: 0 0 16px;
  min-height: 28px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.app-footer__text {
  margin: 0 0 8px;
  font-size: 14px;
  color: #586578;
}

.app-footer__link {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #586578;
  text-decoration: none;
}

.app-footer__link:hover {
  color: #0f172a;
}

.app-footer__divider {
  height: 1px;
  background: #e2e8f0;
  margin-bottom: 24px;
}

.app-footer__bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.app-footer__copy {
  font-size: 14px;
  color: #586578;
}

.app-footer__legal {
  display: flex;
  gap: 16px;
}
</style>
